import { render, staticRenderFns } from "./FooterCatagory.vue?vue&type=template&id=6583c8d0&"
import script from "./FooterCatagory.vue?vue&type=script&lang=js&"
export * from "./FooterCatagory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports